// list of all roles that we are going to configure in Azure AD Application that is used by Front end application.
enum AADRole {
  User = "apoc.user",
  Admin = "apoc.admin",
}

export default AADRole;
